window.addEventListener('load', function () {
  const selectors = [
    '.slideshow__slide',
    '.slide',
    '.slider__slide',
    '.carousel__slide',
    '.swiper-slide'
  ];

  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(slide => {
      const hasImg = slide.querySelector('img[src]:not([src=""])');
      const hasDataImg = slide.querySelector('img[data-src]:not([data-src=""])');
      const hasPicture = slide.querySelector('picture source[srcset], picture img');

      const hasBgImage = Array.from(slide.querySelectorAll('*')).some(el => {
        const bg = window.getComputedStyle(el).backgroundImage;
        return bg && bg !== 'none';
      });

      const text = slide.textContent.replace(/\s+/g, '').trim();

      if (!hasImg && !hasDataImg && !hasPicture && !hasBgImage && !text) {
        slide.remove();
      }
    });
  });
});